Customer.Filters ||= {}

class Customer.Filters.FilterView extends Backbone.View
  template: JST["backbone/templates/customer/filters/filter"]
  className: 'filter-container'

  events:
    "click dt .filter-left-container": "onClickFilter"
    "click .action-edit": "onEditFilter"
    "click .action-delete": "openDestroyAlert"
    "click .action-clone": "onCloneFilter"

  initialize: (@options = {}) ->
    @filterListView = @options.filterListView
    @filter = @options.filter
    @canManage = @options.canManage
    @canManageGlobal = @options.canManageGlobal
    @canSort = @options.canSort
    @isSelected = @options.isSelected
    @isColorActive = @options.isColorActive
    @listenTo(Backbone, 'update:counter', @renderCounter)

  render: ->
    @$el.html @template
      filter: @filter,
      canManage: @canManage,
      canManageGlobal: @canManageGlobal,
      canSort: @canSort,
      isSelected: @isSelected,
      isColorActive: @isColorActive
    _.defer @_renderTooltip
    @renderCounter(@filter)
    @

  renderCounter: (filter_updated) ->
    return if @filter.get('id') != filter_updated.get('id')
    @$el.find('.badge').html(filter_updated.counter)
    _.defer @_renderTooltip

  onClickFilter: (event) =>
    @_keepCustomerSessionAlive()
    unless @isSelected
      @filter.select()
      @filter.setCallSummaryFirstTime(false)

  onEditFilter: () =>
    @_keepCustomerSessionAlive()
    @filterListView.openEditModal(@filter)

  onCloneFilter: () =>
    @_keepCustomerSessionAlive()
    @filterListView.openCloneModal(@filter)

  openDestroyAlert: () =>
    @filterListView.openDestroyAlert(@filter)

  _renderTooltip: =>
    $filterName = @$el.find('.filter-name')
    return unless @_hasOverflow($filterName)
    $filterName.attr('title', $filterName[0].innerText)

  _hasOverflow: ($selector) ->
    $selector[0]?.offsetWidth < $selector[0]?.scrollWidth

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
